import { request } from "../util/request"

export interface GetBandPostParams {
  fields?: string
}

/** Post shape from API; typed loosely for concert/event and other post types. */
export interface BandPostResponse {
  success?: boolean
  post?: {
    title?: string
    start_dt?: string | Date
    duration_minutes?: number
    ticket_type?: string
    content_hash?: { ticket_type?: string; band_nada_ticket_max?: number; ticket_price_at_door?: number; pricing_type?: string; ticket_price?: number; ticket_price_max?: number }
    location?: { displayName?: string }
    ticket_link_url?: string
    description?: string
    cover_image_url?: string | null
    status?: string
    max_rsvps?: number | null
    band_nada_ticket_max?: number | null
    ticket_price_at_door?: number | null
    ticket_price?: number | null
    ticket_price_max?: number | null
    pricing_type?: string | null
    event_performances?: Array<{
      set_time?: string | Date | null
      band_id?: number | null
      band_name?: string
      pending_band_name?: string
      pending_band_email?: string
      is_existing_band?: boolean
    }>
  }
}

/**
 * Fetch a single post (e.g. concert/event) for a band.
 * GET /api/v1/bands/:bandId/posts/:postId
 */
export async function getBandPost(
  bandId: number,
  postId: string | number,
  params?: GetBandPostParams,
): Promise<BandPostResponse> {
  const data = await request({
    queryKey: [
      "bandPost",
      {
        path: `/api/v1/bands/${bandId}/posts/${postId}`,
        params: params ? { fields: params.fields } : undefined,
      },
    ],
  })
  return data as BandPostResponse
}
